import styled from "styled-components";
import Dialog from "../../../../components/dialog/dialog";

export const CreateUserModalStyled = styled(Dialog)`
  width: 55%;

  button {
    color: #301d35 !important;
    border: 1px solid #301d35;
  }
  button:hover {
    background-color: #dedafb !important;
  }
  .head {
    display: flex;
    align-items: flex-end;
    margin: 0 10px;
    padding: 10px 0;
    border-bottom: 1px solid #dedafb;
  }
  .hr {
    margin: 5px 0px 0px 0px;
    color: #dedafb;
  }
  .dialog-body {
    padding: 10px;
  }
`;
